import { InfoText } from '@/modules/common/components/InfoText';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  allFlowStopsAmount: number;
  relatedFlowStopsAmount: number;
}

function NoFlowStopsComponent({ allFlowStopsAmount, relatedFlowStopsAmount }: Props) {
  const { t } = useTranslation('interface');

  if (allFlowStopsAmount === 0) {
    return (
      <InfoText
        header={t('properties.flow_stops.no_flow_stops.title')}
        subHeader={t('properties.flow_stops.no_flow_stops.subtitle')}
        sx={{ width: '90%', margin: '0 auto' }}
      />
    );
  }

  if (relatedFlowStopsAmount === 0) {
    return (
      <InfoText
        header={t('properties.flow_stops.no_related_flow_stops.title')}
        subHeader={t('properties.flow_stops.no_flow_stops.subtitle')}
        sx={{ width: '90%', margin: '0 auto' }}
      />
    );
  }

  return null;
}

export const NoFlowStops = memo(NoFlowStopsComponent);
